import { Link } from "react-router-dom";
import { SITE, CATEGORIES } from "../constants/site";

export const Footer = () => (
  <footer data-testid="footer" className="bg-navy text-white">
    <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-4 py-16 sm:px-8 md:grid-cols-12 lg:px-16">
      <div className="md:col-span-5">
        <div className="flex items-center gap-3">
          <span className="grid h-10 w-10 place-items-center bg-white font-display text-lg font-extrabold text-navy">IBM</span>
          <span className="font-display font-semibold">Ibn Bachir Multimédia</span>
        </div>
        <p className="mt-6 max-w-sm text-sm leading-relaxed text-white/60">Vente de matériel informatique et développement de logiciels de gestion. Dakar, Sénégal.</p>
      </div>
      <div className="md:col-span-3">
        <p className="eyebrow text-gold">Catalogue</p>
        <ul className="mt-4 space-y-2 text-sm text-white/70">{CATEGORIES.map((c) => <li key={c}>{c}</li>)}</ul>
      </div>
      <div className="md:col-span-4">
        <p className="eyebrow text-gold">Contact</p>
        <ul className="mt-4 space-y-2 text-sm text-white/70">
          <li>{SITE.phone}</li><li>{SITE.phone2}</li><li>{SITE.email}</li><li>{SITE.address}</li><li>{SITE.hours}</li>
        </ul>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="mx-auto flex max-w-7xl flex-col gap-3 px-4 py-6 text-xs text-white/40 sm:flex-row sm:items-center sm:justify-between sm:px-8 lg:px-16">
        <span>© {new Date().getFullYear()} {SITE.name}. Tous droits réservés.</span>
        <Link to="/admin/login" data-testid="footer-admin-link" className="underline-link hover:text-gold">Espace administrateur</Link>
      </div>
    </div>
  </footer>
);
